import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import LoginButton from '../components/LoginButton';
import ThemeToggle from '../components/ThemeToggle';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import { useAuth } from '../context/AuthContext';
import TopBar from './TopBar';

function Navbar() {
    const [click, setClick] = useState(false);
    const { isAuthenticated, isAdmin } = useAuth();

    const handleClick = () => setClick(!click);

    const closeMobileMenu = () => {
        setClick(false);
    };

    return (
        <>
            <TopBar />
            <nav className='navbar'>
                <Link to='/' className='navbar-logo' onClick={closeMobileMenu}>
                    StockMaid
                </Link>
                <div className='menu-icon' onClick={handleClick}>
                    <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
                </div>
                <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                    <li className='nav-item'>
                        <Link to='/' className='nav-links' onClick={closeMobileMenu}>
                            Home
                        </Link>
                    </li>

                    <li className='nav-item'>
                        <Link to='/stocks' className='nav-links' onClick={closeMobileMenu}>
                            Products
                        </Link>
                    </li>

                    {isAuthenticated && (
                        <li className='nav-item'>
                            <Link
                                to='/my-tracked-stocks'
                                className='nav-links'
                                onClick={closeMobileMenu}
                            >
                                <BookmarkIcon sx={{ mr: 0.5, fontSize: '0.9rem' }} />
                                Tracked Products
                            </Link>
                        </li>
                    )}

                    {isAdmin && (
                        <li className='nav-item'>
                            <Link
                                to='/admin'
                                className='nav-links'
                                onClick={closeMobileMenu}
                            >
                                Admin
                            </Link>
                        </li>
                    )}

                    <li className='login-mobile'>
                        <div className='login-wrapper'>
                            <ThemeToggle />
                            <LoginButton onNavAction={closeMobileMenu} />
                        </div>
                    </li>
                </ul>
                <div className='nav-auth'>
                    <ThemeToggle />
                    <LoginButton />
                </div>
            </nav>
        </>
    );
}

export default Navbar;
